import { useState } from 'react'
import { branch, renderComponent } from 'recompose'
import { createStructuredSelector } from 'reselect'
import classNames from 'classnames'

import { CardSection } from 'shared/components/CardSection'
import { VehicleTabs } from '@components/VehicleTabs'
import VehicleFormModal from '@components/VehicleFormModal'
import Button from '@components/Button'
import LoginSignUpContainer from '@components/LoginSignUpContainer'
import ErrorMessage from '@components/ErrorMessage'

import { selectVehicle, enableCard } from '@booking/actions'
import { vehiclesSelector, selectedSeasonTicketSelector } from '@booking/selectors'
import { CARDS } from '@booking/reducers'
import { userSelector } from 'auth/selectors'

import VehicleEventDescription from './VehicleEventDescription'

import styles from '../../BookingView/components/styles.module.scss'
import eventStyles from '../styles.module.scss'

const $VehicleSelection = ({
    userVehicles,
    onNext,
    setVehicle,
    selectVehicle,
    rate,
    noLimit = false,
    translate: t,
    bookingData,
}) => {
    const [selectedVehicles, setSelectedVehicles] = useState([])
    const isMultipleVehicle = rate && rate.isMultipleVehicle
    const numberOfVehicles = isMultipleVehicle ? rate.numberOfVehicles : 1
    const selectedVehicleLabel = selectedVehicles.length > 0 && selectedVehicles[0].tag

    const onNextStep = () => {
        onNext()
        setVehicle({ ...selectedVehicles, displayValue: selectedVehicleLabel })
        enableCard([CARDS.CONFIRM_VEHICLE, CARDS.PAY_FOR_PARKING])
        selectVehicle(selectedVehicles)
    }

    return (
        <CardSection className={styles.contentSection} loading={false}>
            <h3 className={eventStyles.headlineMobileVersion}>
                <T>booking.purchase.vehicles</T>
            </h3>
            <VehicleEventDescription bookingData={bookingData} />
            {selectedVehicles.length === 0 && (isMultipleVehicle || noLimit) && (
                <ErrorMessage messages={[t('purchase.flow.vehicles.add.vehicle.warning')]} type="text" />
            )}
            <div className="d-flex flex-column">
                <VehicleTabs
                    setSelectedVehicles={setSelectedVehicles}
                    vehicles={selectedVehicles}
                    userVehicles={userVehicles}
                    maxVehicles={numberOfVehicles}
                    isVehiclesListOpen
                    canAddPlate={false}
                />
                <VehicleFormModal />
                <div className={classNames('row', styles.nextButtonContainer)}>
                    <Button
                        btnStyle="primary"
                        onClick={onNextStep}
                        disabled={selectedVehicles.length < 1}
                        className={styles.nextButton}>
                        <T>subscription.purchase.label.next</T>
                    </Button>
                </div>
            </div>
        </CardSection>
    )
}

const VehicleSelection = compose(
    connect(
        createStructuredSelector({
            userVehicles: vehiclesSelector,
            user: userSelector,
            selectedSeasonTicket: selectedSeasonTicketSelector,
        }),
        { selectVehicle, enableCard }
    ),
    withTranslate,
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent($VehicleSelection))
)(VehicleSelection)

export default VehicleSelection
